/* eslint-disable no-plusplus */
import { format } from "date-fns";
import React, { useState, useContext, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { RootStateOrAny, useSelector } from "react-redux";
import { useLeadsProprios, useLeadsCompartilhados } from "../../services/api";
import { LeadsPropriosInterface } from "../../interfaces/wallet.interface";
import { AuthState } from "../../store/ducks/auth/types";
import { RenderByCargo } from "../../utils/RenderByCargo";
import NavCommon from "../../components/@navHeader";
import { Context } from "../../context/Context";
import Socket from "../../hooks/socket";
import { Container, Box, Tabs, Tab } from "./styles";
import { TableGrid } from "./components/tableGrid";
import { getTotalItensRetorno } from "./components/tableGrid/constants";
import { useExportarLeads } from "../../services/api/AppWeb_Lead/exportar-leads";
import { buildFiltersBody } from "./utils/buildFiltersBody";
import { resolveHierarchyFilters } from "./utils/resolveHierarchyFilters";
import instance from "../../services/axiosServices";
import leadsWebEnviroment from "../../utils/leadsWebEnviroment";

export function Leads() {
  Socket();
  const history = useHistory();
  const [tabValue, setTabValue] = React.useState(0);
  const { filters, setFilters } = useContext(Context);
  const [renderTab, setRenderTab] = useState(false);
  const [prefsLoaded, setPrefsLoaded] = useState(false);
  const [apiColumns, setApiColumns] = useState<string[]>([]);
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const prefsFetched = useRef(false);

  // Carregar último filtro salvo da API ao entrar na carteira
  useEffect(() => {
    if (prefsFetched.current) return;
    prefsFetched.current = true;

    const params = new URLSearchParams(window.location.search);
    if (params.get("fromIndicator") === "true") {
      window.history.replaceState({}, "", "/leads");
      // Os filtros vêm do indicador, mas a quantidade por página continua
      // sendo preferência do usuário.
      setFilters((prev: any) => ({
        ...prev,
        paginationParams: {
          ...prev?.paginationParams,
          TotalItensRetorno: getTotalItensRetorno(prev),
        },
      }));
      setPrefsLoaded(true);
      return;
    }

    const loadPreferencias = async () => {
      try {
        const url = `${leadsWebEnviroment}/commom/leads/preferencias-carteira/v1`;
        const response = await instance.get(url);
        const d = response?.data?.data;
        if (!d) return;

        const mapped: Record<string, any> = {};

        // Ordenação
        if (d.ordenarPorRecentes === true) {
          mapped.OrdenarPorRecentes = "recentes";
        } else if (d.ordenarPorRecentes === false) {
          mapped.OrdenarPorRecentes = "antigos";
        }

        // Booleans → radio
        if (d.identificaCliente === true) {
          mapped.IdentificaCliente = "sim";
        } else if (d.identificaCliente === false) {
          mapped.IdentificaCliente = "nao";
        }
        if (d.visitou === true) {
          mapped.Visitou = "sim";
        } else if (d.visitou === false) {
          mapped.Visitou = "nao";
        }

        // Datas (nomes iguais aos da API)
        if (d.inicioIntervaloCadastroLead || d.fimIntervaloCadastroLead) {
          mapped.FiltrarPorData = "criacao";
          mapped.InicioIntervaloCadastroLead =
            d.inicioIntervaloCadastroLead || null;
          mapped.FimIntervaloCadastroLead = d.fimIntervaloCadastroLead || null;
        }
        if (d.inicioIntervaloAtualizacaoLead || d.fimIntervaloAtualizacaoLead) {
          mapped.FiltrarPorData = "atualizacao";
          mapped.InicioIntervaloAtualizacaoLead =
            d.inicioIntervaloAtualizacaoLead || null;
          mapped.FimIntervaloAtualizacaoLead =
            d.fimIntervaloAtualizacaoLead || null;
        }

        // Transferência
        if (d.filtrarRecebidosPorTransferencia != null) {
          mapped.FiltrarRecebidosPorTransferencia =
            d.filtrarRecebidosPorTransferencia;
        }
        if (d.inicioIntervaloTransferencia) {
          mapped.InicioIntervaloTransferencia = d.inicioIntervaloTransferencia;
        }
        if (d.fimIntervaloTransferencia) {
          mapped.FimIntervaloTransferencia = d.fimIntervaloTransferencia;
        }

        // Arrays
        const setArr = (key: string, val: any) => {
          if (Array.isArray(val) && val.length > 0) mapped[key] = val;
        };
        setArr("IdsOrigem", d.idsOrigem);
        setArr("IdsCanalContato", d.idsCanalContato);
        setArr("Etapas", d.etapas);
        setArr("IdSubEtapaFunil365", d.idSubEtapaFunil365);
        setArr("IdsEtiquetas", d.idsEtiquetas);
        setArr("Status", d.farois);
        setArr("IdsTemperaturasLead", d.idsTemperaturasLead);
        setArr("IdsRendaFamiliares", d.idsRendaFamiliares);
        setArr("IdsEmpreendimentos", d.idsEmpreendimentos);
        setArr("IdsTipoEmpreendimentos", d.idsTipoEmpreendimentos);
        setArr(
          "QuantidadesDormitorios",
          d.quantidadesDormitorios?.map((v: number) => String(v))
        );
        setArr("IdsZonasEmpreendimentos", d.idsZonasEmpreendimentos);
        setArr("IdsBairrosEmpreendimentos", d.idsBairrosEmpreendimentos);
        setArr("IdsObjetivosCompra", d.idsObjetivosCompra);
        setArr("IdsPrazosEntrega", d.idsPrazosEntrega);
        setArr("IdsEquipes", d.idsEquipes);
        setArr("IdsCorretores", d.idsCorretores);

        // Filtro salvo
        if (d.idFiltro) {
          mapped.idFiltro = d.idFiltro;
        }

        // Booleans diretos
        if (d.semEmpreendimentoInteresse) {
          mapped.SemEmpreendimentoInteresse = true;
        }

        // Valores
        if (d.inicioIntervaloValorImovel) {
          mapped.InicioIntervaloValorImovel = d.inicioIntervaloValorImovel;
        }
        if (d.fimIntervaloValorImovel) {
          mapped.FimIntervaloValorImovel = d.fimIntervaloValorImovel;
        }

        // Tipo de visualização (1 = Lista, 2 = KanbanEtapa)
        if (d.tipoVisualizacao === 1 || d.tipoVisualizacao === 2) {
          mapped.TipoVisualizacao = d.tipoVisualizacao;
        }

        // Colunas da carteira
        if (Array.isArray(d.colunasCarteira) && d.colunasCarteira.length > 0) {
          setApiColumns(d.colunasCarteira);
        }

        // Quantidade por página: preferência do backend tem prioridade; sem
        // ela, mantém a que o usuário já estava usando nesta navegação.
        const quantidadePersistida = Number(d.quantidadePorPagina);

        // Aplicar se houver filtro mapeado ou quantidade persistida
        if (Object.keys(mapped).length > 0 || quantidadePersistida > 0) {
          setFilters((prev: any) => ({
            ...prev,
            ...mapped,
            paginationParams: {
              PaginaAtual: 1,
              PalavrasChave: "",
              TotalItensRetorno:
                quantidadePersistida > 0
                  ? quantidadePersistida
                  : getTotalItensRetorno(prev),
              OrdenarPorOrdemAlfabetica: "",
            },
          }));
        }
      } catch {
        // Degradação graceful — mantém filtros do localStorage
      } finally {
        setPrefsLoaded(true);
      }
    };

    loadPreferencias();
  }, []);

  const recuperarTab = async () => {
    const chaveLocalStorage = "@LeadTab";
    const tab = await localStorage.getItem(chaveLocalStorage);
    if (tab) {
      setTabValue(parseInt(tab, 10));
      setRenderTab(true);
    } else {
      setTabValue(0);
      setRenderTab(true);
    }
  };

  React.useEffect(() => {
    recuperarTab();
  }, []);

  const handleFiltersExcel = (leadsFilters: LeadsPropriosInterface): string => {
    const filterData: string[] = [];

    const formatDate = (dateStr: string | null): string | null => {
      if (!dateStr) return null;
      const date = new Date(dateStr);
      return format(date, "yyyy-MM-dd");
    };

    const addQueryParam = (param: string, value: any) => {
      if (value !== null && value !== undefined) {
        filterData.push(`${param}=${value}`);
      }
    };

    addQueryParam(
      "InicioIntervaloCadastroLead",
      formatDate(leadsFilters.InicioIntervaloCadastroLead || null)
    );
    addQueryParam(
      "FimIntervaloCadastroLead",
      formatDate(leadsFilters.FimIntervaloCadastroLead || null)
    );
    addQueryParam(
      "InicioIntervaloAtualizacaoLead",
      formatDate(leadsFilters.InicioIntervaloAtualizacaoLead || null)
    );
    addQueryParam(
      "FimIntervaloAtualizacaoLead",
      formatDate(leadsFilters.FimIntervaloAtualizacaoLead || null)
    );
    addQueryParam(
      "InicioIntervaloTransferencia",
      formatDate(leadsFilters.InicioIntervaloTransferencia || null)
    );
    addQueryParam(
      "FimIntervaloTransferencia",
      formatDate(leadsFilters.FimIntervaloTransferencia || null)
    );
    addQueryParam(
      "FiltrarRecebidosPorTransferencia",
      leadsFilters.FiltrarRecebidosPorTransferencia
    );
    addQueryParam(
      "SemEmpreendimentoInteresse",
      leadsFilters.SemEmpreendimentoInteresse
    );
    addQueryParam("LeadsDesqualificados", leadsFilters.LeadsDesqualificados);
    if (leadsFilters.OrdenarPorRecentes) {
      addQueryParam(
        "OrdenarPorRecentes",
        leadsFilters.OrdenarPorRecentes === "recentes"
      );
    }
    if (leadsFilters.IdentificaCliente) {
      addQueryParam(
        "IdentificaCliente",
        leadsFilters.IdentificaCliente === "sim"
      );
    }
    if (leadsFilters.Visitou) {
      addQueryParam("Visitou", leadsFilters.Visitou === "sim");
    }
    // Inversão específica para Excel: se for 3 envia 2, se for 2 envia 3
    leadsFilters.Status?.forEach((item) => {
      let statusValue = item;
      if (item === 3) {
        statusValue = 2; // Desatualizará em breve
      } else if (item === 2) {
        statusValue = 3; // Desatualizado
      }
      addQueryParam("Status", statusValue);
    });
    leadsFilters.IdsTemperaturasLead?.forEach((item) =>
      addQueryParam("IdsTemperaturasLead", item)
    );
    leadsFilters.QuantidadesDormitorios?.forEach((item) =>
      addQueryParam("QuantidadesDormitorios", item)
    );
    leadsFilters.IdsZonasEmpreendimentos?.forEach((item) =>
      addQueryParam("IdsZonasEmpreendimentos", item)
    );
    leadsFilters.IdsOrigem?.forEach((item: any) =>
      addQueryParam("IdsOrigem", item?.value)
    );
    leadsFilters.IdsCanalContato?.forEach((item: any) =>
      addQueryParam("IdsCanalContato", item?.value)
    );
    const hierarchyFilters = resolveHierarchyFilters(leadsFilters);
    hierarchyFilters.IdsEquipes?.forEach((item) =>
      addQueryParam("IdsEquipes", item)
    );
    leadsFilters.IdMotivoDesqualificacaoLead365?.forEach((item: any) =>
      addQueryParam("IdMotivoDesqualificacaoLead365", item?.value)
    );
    hierarchyFilters.IdsCorretores?.forEach((item) =>
      addQueryParam("IdsCorretores", item)
    );
    hierarchyFilters.IdUsuarioGerente?.forEach((item) =>
      addQueryParam("IdUsuarioGerente", item)
    );
    hierarchyFilters.IdUsuarioSuperintendente?.forEach((item) =>
      addQueryParam("IdUsuarioSuperintendente", item)
    );
    leadsFilters.IdsRendaFamiliares?.forEach((item: any) =>
      addQueryParam("IdsRendaFamiliares", item?.value)
    );
    leadsFilters.IdsEmpreendimentos?.forEach((item: any) =>
      addQueryParam("IdsEmpreendimentos", item?.value)
    );
    leadsFilters.IdsTipoEmpreendimentos?.forEach((item) =>
      addQueryParam("IdsTipoEmpreendimentos", item)
    );
    leadsFilters.IdsBairrosEmpreendimentos?.forEach((item: any) =>
      addQueryParam("IdsBairrosEmpreendimentos", item?.value)
    );
    addQueryParam(
      "InicioIntervaloValorImovel",
      leadsFilters.InicioIntervaloValorImovel
    );
    addQueryParam(
      "FimIntervaloValorImovel",
      leadsFilters.FimIntervaloValorImovel
    );
    leadsFilters.IdsObjetivosCompra?.forEach((item) =>
      addQueryParam("IdsObjetivosCompra", item)
    );
    leadsFilters.IdsPrazosEntrega?.forEach((item) =>
      addQueryParam("IdsPrazosEntrega", item)
    );
    leadsFilters.Etapas?.forEach((item) => addQueryParam("Etapas", item));
    leadsFilters.IdSubEtapaFunil365?.forEach((item: any) =>
      addQueryParam("IdSubEtapaFunil365", item?.value)
    );
    leadsFilters.IdsEtiquetas?.forEach((item: any) =>
      addQueryParam("IdsEtiquetas", item)
    );
    addQueryParam("OrdenacaoLeads", leadsFilters.OrdenacaoLeads);
    addQueryParam("OrdenacaoCrescente", leadsFilters.OrdenacaoCrescente);
    addQueryParam(
      "PalavrasChave",
      leadsFilters.paginationParams?.PalavrasChave
    );
    return `&${filterData.join("&")}`;
  };

  const {
    data: dataLeadsProprios,
    refetch: refetchLeadsProprios,
    isLoading: isFetchingLeadsProprios,
    isFetching: isRefetchingLeadsProprios,
  } = useLeadsProprios({
    queryKey: "leads_proprios",
    body: buildFiltersBody(filters),
  });

  const {
    data: dataLeadsCompartilhados,
    refetch: refetchLeadsCompartilhados,
    isLoading: isFetchingLeadsCompartilhados,
    isFetching: isRefetchingLeadsCompartilhados,
  } = useLeadsCompartilhados({
    queryKey: "leads_compartilhados",
    body: buildFiltersBody(filters),
  });

  const {
    data: carteiraExportada,
    refetch: refetchCarteiraExportada,
    isFetching: isLoadingExcel,
    isFetched,
  } = useExportarLeads({
    queryKey: "exportar_leads_carteira",
    LeadsProprios: tabValue === 0,
    params: handleFiltersExcel(filters),
  });

  React.useEffect(() => {
    if (isFetched) {
      const base64String = carteiraExportada?.data?.base64Planilha;
      const binaryData = atob(base64String);
      const byteArray = new Uint8Array(binaryData.length);

      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `Carteira_Leads_${
        tabValue !== 0 ? "Compartilhados" : "Proprios"
      }_${format(new Date(), "dd_MM_yyyy-H'h'mm'm'ss's'")}.xlsx`; // Nome do arquivo de saída
      a.click();

      URL.revokeObjectURL(blobUrl);
    }
  }, [isFetched, carteiraExportada]);

  React.useEffect(() => {
    if (!prefsLoaded) return;
    if (tabValue === 0) {
      refetchLeadsProprios();
    } else {
      refetchLeadsCompartilhados();
    }
  }, [filters, tabValue, renderTab, prefsLoaded]);

  const handleChange = (event: any, newValue: any) => {
    setTabValue(newValue);
    localStorage.setItem("@LeadTab", newValue.toString());
  };

  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function thisProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "", name: "Carteira" }]}
        showButtonNew
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/leads-novo")}
      />
      {renderTab ? (
        <Container>
          <Box>
            <RenderByCargo
              cargo={codigoCargo2013}
              isCorretor={
                <Tabs
                  indicatorColor="secondary"
                  value={tabValue}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Leads próprios" {...thisProps(0)} />
                  <Tab label="Leads compartilhados" {...thisProps(1)} />
                </Tabs>
              }
            />
          </Box>
          <TabPanel value={tabValue} index={0}>
            <TableGrid
              leads={dataLeadsProprios?.data?.leadsDataResponse}
              loading={isFetchingLeadsProprios}
              refetching={isRefetchingLeadsProprios}
              isShared={false}
              requestLeads={refetchLeadsProprios}
              currentPage={dataLeadsCompartilhados?.pagination?.currentPage}
              totalPages={dataLeadsProprios?.pagination?.quantityPages}
              totalItems={dataLeadsProprios?.pagination?.totalItems}
              filtersCount={dataLeadsProprios?.data?.quantidadeFiltrosAplicados}
              onHandleExcel={() => refetchCarteiraExportada()}
              isLoadingExcel={isLoadingExcel}
              apiColumns={apiColumns}
            />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <TableGrid
              leads={dataLeadsCompartilhados?.data?.leadsDataResponse}
              loading={isFetchingLeadsCompartilhados}
              refetching={isRefetchingLeadsCompartilhados}
              isShared
              requestLeads={refetchLeadsCompartilhados}
              currentPage={dataLeadsCompartilhados?.pagination?.currentPage}
              totalPages={dataLeadsCompartilhados?.pagination?.quantityPages}
              totalItems={dataLeadsCompartilhados?.pagination?.totalItems}
              filtersCount={
                dataLeadsCompartilhados?.data?.quantidadeFiltrosAplicados
              }
              onHandleExcel={() => refetchCarteiraExportada()}
              isLoadingExcel={isLoadingExcel}
              apiColumns={apiColumns}
            />
          </TabPanel>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
}
